import { META_PIXEL_ID } from '../data/analytics'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

const FBEVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

let initialized = false

/**
 * Official Meta Pixel base code for Pequeñas Puntadas™.
 * - Loads fbevents.js once and initializes only META_PIXEL_ID.
 * - Sends a single PageView per page load, addressed with trackSingle so it
 *   only reaches this pixel even if another pixel were present on the page.
 * - No other events are sent from the landing: InitiateCheckout and Purchase
 *   are configured in Impultienda (checkout), never on load or on in-page buttons.
 */
export function initMetaPixel(): void {
  if (!META_PIXEL_ID || initialized) return
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(window, document, 'script', FBEVENTS_SRC)
  /* eslint-enable */

  // Never load fbevents.js twice (e.g. a leftover tag in the host page).
  const scripts = document.querySelectorAll(`script[src="${FBEVENTS_SRC}"]`)
  scripts.forEach((node, index) => {
    if (index > 0) node.remove()
  })

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('trackSingle', META_PIXEL_ID, 'PageView')

  // The <noscript> fallback only works as static markup in index.html (a
  // script-built <noscript> would fire a duplicate PageView). If the host
  // page supports it, the only valid fallback is:
  // <noscript><img height="1" width="1" style="display:none"
  //   src="https://www.facebook.com/tr?id=971936332634523&ev=PageView&noscript=1" /></noscript>
  // Defensive cleanup of any legacy script-injected node from the old project.
  document.getElementById('meta-pixel-noscript')?.remove()
}
